import { render, staticRenderFns } from "./EntityCheckupMeasurementGroups.vue?vue&type=template&id=f8e409fc&scoped=true"
import script from "./EntityCheckupMeasurementGroups.vue?vue&type=script&lang=js"
export * from "./EntityCheckupMeasurementGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e409fc",
  null
  
)

export default component.exports